/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertRfi,
    InternalApiAlertRfiFromJSON,
    InternalApiAlertRfiToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
} from '../models';

export interface GetAlertRfiRequest {
    alertId: number;
    alertType: InternalApiAlertType;
}

/**
 * 
 */
export class AlertRfiApi extends runtime.BaseAPI {

    /**
     * Get alert rfi
     */
    async getAlertRfiRaw(requestParameters: GetAlertRfiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertRfi>> {
        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling getAlertRfi.');
        }

        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling getAlertRfi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-rfi/{alertType}/{alertId}`.replace(`{${"alertId"}}`, encodeURIComponent(String(requestParameters.alertId))).replace(`{${"alertType"}}`, encodeURIComponent(String(requestParameters.alertType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertRfiFromJSON(jsonValue));
    }

    /**
     * Get alert rfi
     */
    async getAlertRfi(requestParameters: GetAlertRfiRequest, initOverrides?: RequestInit): Promise<InternalApiAlertRfi> {
        const response = await this.getAlertRfiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
